<template>
  <div>
    <div :id="id" :style="{height:height,width:width}"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import resize from './mixins/resize'
export default {
  mixins: [resize],
  props: {
    option: {
      type: Object
    },
    id: {
      type: String,
      default: 'chart'
    },
    name: {
      type: String
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  data () {
    return {
      chart: null
    }
  },
  mounted () {
    this.initChart()
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      this.chart = echarts.init(document.getElementById(this.id), {}, { renderer: 'svg' })
      let optionData = this.option.data
      let indicator = []
      let seriesValue = []
      for (var a in optionData) {
        let value = parseInt(optionData[a].value)
        seriesValue.push(value)
      }
      let max = seriesValue.reduce(function (prev, cur) {
        return Math.max(prev, cur)
      })
      for (var formItem in optionData) {
        indicator.push({
          name: optionData[formItem].name,
          max: max
        })
      }

      this.chart.setOption({
        backgroundColor: '#2A3042',
        tooltip: {},

        radar: [{ // 雷达图坐标系组件，只适用于雷达图。
          center: ['50%', '50%'], // 圆中心坐标，数组的第一项是横坐标，第二项是纵坐标。[ default: ['50%', '50%'] ]
          radius: 110, // 圆的半径，数组的第一项是内半径，第二项是外半径。
          startAngle: 45, // 坐标系起始角度，也就是第一个指示器轴的角度。[ default: 90 ]
          name: { // (圆外的标签)雷达图每个指示器名称的配置项。
            formatter: '{value}',
            textStyle: {
              fontSize: 12,
              color: '#fff',
              backgroundColor: '#232839',
              borderRadius: 3,
              padding: [5, 8]
            }
          },
          nameGap: 15, // 指示器名称和指示器轴的距离。[ default: 15 ]
          splitNumber: 5, // (这里是圆的环数)指示器轴的分割段数。[ default: 5 ]
          shape: 'circle', // 雷达图绘制类型，支持 'polygon'(多边形) 和 'circle'(圆)。[ default: 'polygon' ]
          axisLine: { // (圆内的几条直线)坐标轴轴线相关设置
            lineStyle: {
              color: 'rgba(225,255,255,0.3)', // 坐标轴线线的颜色。
              width: 1, // 坐标轴线线宽。
              type: 'solid' // 坐标轴线线的类型。
            }
          },
          splitLine: { // (这里是指所有圆环)坐标轴在 grid 区域中的分隔线。
            lineStyle: {
              color: 'rgba(255,255,255,.1)', // 分隔线颜色
              width: 2// 分隔线线宽
            }
          },
          splitArea: { // 坐标轴在 grid 区域中的分隔区域，默认不显示。
            show: true,
            areaStyle: { // 分隔区域的样式设置。
              color: [] // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
            }
          },
          indicator: indicator
        }],
        series: [{
          type: 'radar',
          itemStyle: {
            normal: {
              lineStyle: {
                width: 1
              },
              opacity: 0
            },
            emphasis: {
              lineStyle: {
                width: 5
              },
              opacity: 0
            }
          },
          data: [{
            name: this.name,
            value: seriesValue,
            symbol: 'circle',
            symbolSize: 5,
            lineStyle: {
              normal: {
                opacity: 0
              }
            },
            areaStyle: {
              normal: {
                color: '#009AFF'
              }
            }
          }]
        }]
      })
    }
  },
  created () {
  }
}
</script>
